(function () {
	'use strict';

	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	const isMobile = window.matchMedia(
		'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	);
	const navigationResponsiveContainer = document.querySelector(
		'.site-header .wp-block-navigation__responsive-container'
	);
	isMobile.onchange = (e) => {
		if (e.matches) {
			// <= Mobile
		} else {
			// > Mobile
			// Autoclose header nav container if modal is open and browser window gets resized.
			if (
				document.body.contains(navigationResponsiveContainer) &&
				navigationResponsiveContainer.classList.contains('is-menu-open')
			) {
				document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
			}
		}
	};
	

	window.onscroll = function() {
		stickyMenu();
	};
	const header = document.querySelector('header.wp-block-template-part');
	const sticky = header.offsetTop;
	function stickyMenu() {
		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
		}
	}
	stickyMenu();
	/*var swiper = new Swiper('.gs-swiper-init',
		{
		 on: {
			 afterInit: function(swiperr) {
				//console.log(swiperr);

				swiperr.originalParams.effect = 'coverflow';
				swiperr.originalParams.coverflowEffect.grabCursor = true;
				swiperr.originalParams.coverflowEffect.centeredSlides = true;
				swiperr.originalParams.coverflowEffect.slidesPerView = "auto";
				swiperr.originalParams.coverflowEffect.rotate = 50;
				swiperr.originalParams.coverflowEffect.stretch = 0;
				swiperr.originalParams.coverflowEffect.depth = 1200;
				swiperr.originalParams.coverflowEffect.modifier = 1;
				swiperr.originalParams.coverflowEffect.slideShadows = true;	

				swiperr.update();
			 }
		 }
	   }
	);*/

})();
